import { connect } from 'react-redux'

import * as actions from '../actions'
import * as selectors from '../selectors'
import EmailAddress from '../components/EmailAddress'


const mapStateToProps = state => {
    return {
        isRequestingPassword: selectors.isRequestingPassword(state),
        requestedPassword: selectors.requestedPassword(state)
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onReset: () => dispatch(actions.resetRequestPassword()),
        onSend: email => dispatch(actions.requestPassword(email))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailAddress)



/** WEBPACK FOOTER **
 ** ./src/containers/EmailAddressContainer.js
 **/